<template>
  <div v-loading="loading">
    <div class="title">面试列表</div>
    <!-- <div class="search-box">
      <el-input
        clearable
        size="mini"
        @keyup.enter.native="handleSearch"
        placeholder="岗位名称"
        class="w-180 mr-12"
        v-model="job_name"
      ></el-input>

      <el-button type="primary" size="mini" @click="handleSearch"
        >搜索</el-button
      >
      <el-button type="default" size="mini" @click="handleReset"
        >重置</el-button
      >
    </div> -->
    <el-table :data="tableData" :stripe="true">
      <el-table-column width="80" label="ID" prop="id"></el-table-column>
      <el-table-column width="120" label="岗位名称" prop="job_name">
      </el-table-column>
      <el-table-column label="面试名称" prop="title"> </el-table-column>
      <el-table-column width="200" prop="start_at" label="开始时间">
      </el-table-column>
      <el-table-column width="55" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="grabOrder(scope.row.uuid)"
            >抢单</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="handleChangePage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import interviewService from "@/global/service/interview";
export default {
  components: {},
  data() {
    return {
      loading: true,
      isShow: false,
      job_name: "",
      homeworkId: null,
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0
      },
      search: {
        challenge_name: null,
        student_search: null,
        company_name: null
      },
      currentMd: "",
      show: false,
      project_content: [],
      project_name: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
        job_name: this.job_name
      };
      this.loading = true;
      interviewService
        .getInterviewsList(params)
        .then(res => {
          this.tableData = res.list;
          this.pagination.currentPage = res.pagination.current_page;
          this.pagination.total = res.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.getData();
    },
    handleReset() {
      this.search = {
        project_name: null,
        student_name: null
      };
      this.pagination.currentPage = 1;
      this.getData();
    },
    handleChangePage(e) {
      this.pagination.currentPage = e;
      this.getData();
    },
    grabOrder(id) {
      interviewService.interviewGrab(id).then(() => {
        this.$message.success("抢单成功～");
        this.getData();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.search-box {
  margin: 20px 0 10px;
}
.md-border {
  padding: 10px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 12px;
  &:last-child {
    border: none;
  }
}
.dialog-title {
  font-size: 20px;
  margin-bottom: 12px;
}
</style>
